<template>
<!-- 'activated' class for second styles  -->
    <div id="trial" class="trial" :class="`${user ? 'activated' : ''}`">
        <div data-name="section-title">
            <p><span>FREE</span> 14-day trial</p>
        </div>
        <div data-name="trial-description">
            <ul>
                <li>
                    <Icon icon="colored-ok"/>
                    <p>Multiple Campaigns Management</p>
                </li>
                <li>
                    <Icon icon="colored-ok"/>
                    <p>Unlimited CrossProm Requests</p>
                </li>
                <li>
                    <Icon icon="colored-ok"/>
                    <p>Unlimited Messaging</p>
                </li>
                <li data-name="with-star">
                    <Icon icon="star-pricing-purple"/>
                    <p class="font-weight-bold">Automatic Kickstarter update posting</p>
                </li>
            </ul>
        </div>
        <div class="d-flex justify-content-center">
            <Button class="btn-outline" v-if="!user" @click.native="showModal">
                <span>Start the Trial</span>
            </Button> 
            <span v-else-if="user" class="text-activated">
                {{trialStatus}}
            </span>
        </div>
        <!-- overlay <div> show if activated -->
        <div class="overlay" v-if="user"></div>
    </div>
</template>

<script>
import Button from '@/components/Theme/Button'
import Icon from '@/components/Theme/Icon'
import {mapState, mapGetters} from 'vuex'

export default {
    name: 'Trial',
    components: {
        Icon,
        Button
    },
    computed: {
        ...mapState(['user']),
        ...mapGetters(['trialExpired', 'membershipStatus']),
        trialStatus(){
            if(!this.user.trial) {
                return 'Not Active'
            }
            if(!this.trialExpired && !this.membershipStatus) {
                return 'Activated'
            }
            return 'Expired'
        }
    }, 
    methods: {
        showModal(){
            this.$store.commit('TOGGLE_MODAL', ['sign-up', {
                openedFrom: 'Pricing Page Trial',
                chosenPlanOnSignup: {
                    name: 'basic'
                }
            }]);
        },
    }
}
</script>

<style lang="scss" scoped>
$desctop_width: 432px;
$tab_width: 326px;
$mob_width: 100%;
$fontsize: 16px;
$color: #333333;
$title_fontsize: 24px;
$title_fontweight: 700;
$desctop_fontsize: 18px;
$mob_fontsize: 16px;
$desktop_paddingtop: 32px;
$desktop_paddingleft: 36px;
$desktop_paddingbottom: 32px;
$desktop_paddingleft: 36px;
$mob_paddingleft: 24px;
$mob_paddingright: 24px;
$btn_margintop_desktop: 77px;
$btn_margintop_tab: 68px;
$btn_margintop_mob: 32px;
$primary: #727CF5;
$btn_desktop_width: 200px;
$btn_mob_width: 100%;
$font: 'EinaBold';

div.trial {
    width: $desctop_width;
    background: #ffffff;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
    padding-top: $desktop_paddingtop;
    padding-left: $desktop_paddingleft;
    padding-bottom: $desktop_paddingbottom;
    position: relative;

    &.activated {
        button {
            border: 0 !important;
        }
    }
    div.overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #ffffff96;
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
    }
    p {
        margin-bottom: 0;
    }
    div[data-name="section-title"] {
        position: relative;
        p {
            color: $color;
            font-size: $title_fontsize;
            font-weight: $title_fontweight;
        }
        span {
            position: relative;
            &::before {
                content: '';
                position: absolute;
                height: 3px;
                width: 100%;
                background: $primary;
                top: 100%;
                left: 0;
                transform: translate(0, 10px);
            }
        }
        
    }
    div[data-name="trial-description"] {
        margin-top: 42px;
        ul {
            padding: 0;
            li {
                display: flex;
                margin-bottom: 16px;
                &:last-child {
                    margin-bottom: 0;
                }
                p {
                    margin-left: 10px;
                    font-size: $desctop_fontsize;
                    color: $color;
                }
            }
        }
    }
    button {
        width: $btn_desktop_width;
        height: 48px;
        margin-top: $btn_margintop_mob;
        
        @media screen and (min-height: 900px) {
            margin-top: $btn_margintop_desktop;
        }
    }
    span.text-activated {
        margin-top: $btn_margintop_desktop;
        font-size: 16px;
        color: #727CF5;
        font-weight: bold;
        margin-top: $btn_margintop_mob;

        @media screen and (min-height: 900px) {
            margin-top: $btn_margintop_desktop;
        }
    }
}
@media (max-width: 768px) {
    div.trial {
        width: $tab_width;
        div[data-name="trial-description"] {
            ul {
                li {
                    p {
                        font-size: $mob_fontsize;
                    }
                }
            }
        }
        button {
            margin-top: $btn_margintop_tab;
        }
        span {
            margin-top: $btn_margintop_tab;
        }
    }
}
@media (max-width: 576px) {
    div.trial {
        width: $mob_width;
        margin-top: 32px;
        padding-right: $mob_paddingright;
        padding-left: $mob_paddingleft;
        border-radius: 10px;
        button {
            width: $btn_mob_width;
            margin-top: $btn_margintop_mob;
        }
        span {
            margin-top: $btn_margintop_mob;
        }
    }
}
</style>